/**
 * The message a failed API call should show the user.
 *
 * Most Lasso endpoints answer errors with `errMsg(code, message)`, whose response body IS
 * the message string — not `{ message }`. Reading `data.message` from that body yields
 * undefined, so every careful server-side explanation (out of tokens, job cap, "already
 * applied", "original file gone") degrades to axios's "Request failed with status code N".
 * Routes that bypass errMsg (multer, the auth middlewares) do send `{ message }`, so both
 * shapes are read.
 */
export const messageFrom = (err, fallback) => {
  const data = err && err.response && err.response.data
  const status = err && err.response && err.response.status
  return (typeof data === 'string' && data) ||
    (data && (data.message || data.error)) ||
    (status ? `request failed (HTTP ${status})` : (err && err.message)) ||
    fallback
}
